webpackJsonp([263791100135453],{

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bike3.8ed83a68.jpg";

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/couch3.3f3b5e90.jpg";

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic08.fe7e3185.jpg";

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic10.84b61f15.jpg";

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _pic = __webpack_require__(54);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(55);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	var _couch = __webpack_require__(133);
	
	var _couch2 = _interopRequireDefault(_couch);
	
	var _bike = __webpack_require__(132);
	
	var _bike2 = _interopRequireDefault(_bike);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Jody Smith - Homepage'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'About Me Page' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'main' },
	      _react2.default.createElement(
	        'section',
	        { id: 'banner', className: 'style2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner' },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'About Me'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'I like to code, run spartan races and solve interesting problems.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'one' },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner' },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'My Work'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'I am a life long learner and enjoy problem solving either for work or just for fun. My career started in the IT department doing Network Adminstration and I moved through Technical Sales and eventually ended up in Product Management. When the chance to learn how to code was available, I jumped at the chance to learn the one thing I felt I had been missing for so long.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'two', className: 'spotlights' },
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement('img', { src: _pic2.default, alt: 'Spartan Racing' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inner' },
	              _react2.default.createElement(
	                'header',
	                { className: 'major' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Spartan and OCR races'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'I recently started running in Spartan races, because, why not? Miles and miles of hilly terrain with obstacles that feel like they were designed to break you. It\'s been a fun way to get back in shape and set a fitness goal. By the end of 2018 I completeed my first Spartan Trifecta (a Sprint, Super and Beast race of 7, 14 and 21km length). Aroo!'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement('img', { src: _couch2.default, alt: '' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inner' },
	              _react2.default.createElement(
	                'header',
	                { className: 'major' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'I once built a couch from scratch'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'I like to solve problems, so when I moved into my new house and the basement stairs weren\'t big enough for a larger couch, I built one. From learning wood work to build the frame, upholstery to afix the webbing, all the way to learning to sew for the cushions as well. It took a while, but the result was great :)'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement('img', { src: _bike2.default, alt: '' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inner' },
	              _react2.default.createElement(
	                'header',
	                { className: 'major' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'I Rebuilt a Motorcycle'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'I used to own a GSXR 600 race bike, I had way too much fun on it. One day while riding on the "twisties", my inherant love of going fast was cut short by my lack of skill. I was unlucky enough to hit a little gravel on a sharp turn, and lucky enough to walk away from an insurance write off of my bike, with a sprained thumb. You win some you lose some. What do you do with a wrecked bike? You rebuild it. Thankfully the engine and frame were good, so I didn\'t have to get my hands too dirty. I got two more seasons out of it before I decided to quit while I was ahead. Now I get around on four wheels.'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement('img', { src: _pic4.default, alt: '' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inner' },
	              _react2.default.createElement(
	                'header',
	                { className: 'major' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'I Used to be a Bartender'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'In a previous life I used to bartend downtown in Montreal, it turns out that not only is it a lot of fun, but talking to all kinds of people about all kinds of subjects helped a lot in learning how to best understand peoples problems when it came to product management. I also do a fair amount of public speaking on Digital Signage and Programmatic, and being able to talk to complete strangers like we\'re old friends just makes things easier.'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	// import pic09 from '../assets/images/pic09.jpg'
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-b5682f4ecb5358e12211.js